import { Space } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { useEditModeToolbar } from '../model';
import styles from './styles.module.scss';

export const EditModeToolbar = () => {
  const {
    state: { changesCount, saveIsLoading },
    methods: { handleCancelEditMode, handleSaveEditMode },
  } = useEditModeToolbar();

  return (
    <div className={styles.bar}>
      <AppFlex direction="row" alignItems="center" justifyContent="space-between">
        <div className={styles.info}>
          <span className={styles.title}>Режим редактирования</span>
          <span className={styles.counter}>Изменено уроков: {changesCount}</span>
        </div>

        <Space size="small">
          <AppButton type="outline" onClick={handleCancelEditMode}>
            Отменить
          </AppButton>
          <AppButton
            type="primary"
            onClick={handleSaveEditMode}
            disabled={changesCount === 0}
            loading={saveIsLoading}
          >
            Сохранить
          </AppButton>
        </Space>
      </AppFlex>
    </div>
  );
};
